import requestData from "@/http/request";

/**
 * 报价品质名称列表
 */
export function getQuoteTypeNameListRequest({ ins_id, }) {
  return requestData('/apsapi/jnquote/getQuoteTypeNameList', 'POST', {
    ins_id,
  })
}

/**
 * 撤回报价，目前只有驾安配用
 * @param inquiry_id
 * @returns 
 */
export function recallQuotePriceRequest({ inquiry_id, }){
  return requestData('/apsapi/jnquote/recallQuotePrice','POST',{
    inquiry_id,
  })
}

/**
 * 报价列表搜索，询价机构多级级联，配件商合作的保险公司
 * @returns
 */
export function getDealerCooperateInsuraceCompanyListRequest(){
  return requestData('/apsapi/queryprice/getInsList')
}

/**
 * 更新配件请求的接口，目前是创配才更新
 */
export function updatePartRequest({
  inquiry_id,
}) {
  return requestData('/apsapi/jnquote/updateAdditionalPart','POST', {
    inquiry_id,
  })
}

export function getQuoteStatistics({
  startTime,
  endTime,
  provinceId,
  branchId,
  insId,
}) {
  return requestData('/apsapi/jnquote/getQuoteStatistics','POST',{
    startTime,
    endTime,
    provinceId,
    branchId,
    insId,
  })
}